import React from "react";

const Dropdown2 = () => {
  return <div className="dropdown-2">Dropdown 2</div>;
};

export default Dropdown2;
